import React from 'react';
import { Link } from 'react-router-dom';
import PublicPageShell from '../components/PublicPageShell';
import { useLanguage } from '../contexts/LanguageContext';
import { getLocalizedLegalPage } from '../data/contentLibrary';

const LegalPage = ({ pageId }) => {
  const { currentLang, t } = useLanguage();
  const page = getLocalizedLegalPage(pageId, currentLang);

  if (!page) return null;

  return (
    <PublicPageShell mainClassName="pt-20">
      <section className="relative overflow-hidden bg-black">
        <div className="hero-grid absolute inset-0 pointer-events-none" />
        <div className="relative mx-auto max-w-[980px] px-5 py-16 md:px-[7.6923%] md:py-24">
          <p className="mb-4 text-sm font-semibold uppercase text-[#00FFD1]">
            {page.eyebrow}
          </p>
          <h1 className="text-4xl font-semibold leading-tight text-white md:text-6xl">
            {page.title}
          </h1>
          <p className="mt-6 text-base leading-8 text-white/64 md:text-lg">
            {page.intro}
          </p>
        </div>
      </section>

      <section className="bg-[#050706] py-14 md:py-20">
        <div className="mx-auto max-w-[980px] px-5 md:px-[7.6923%]">
          <div className="space-y-5">
            {page.sections.map((section) => (
              <article
                key={section.heading}
                className="rounded-2xl border border-white/[0.08] bg-white/[0.025] p-6"
              >
                <h2 className="text-2xl font-semibold text-white">
                  {section.heading}
                </h2>
                <p className="mt-3 text-base leading-8 text-white/62">
                  {section.body}
                </p>
              </article>
            ))}
          </div>

          <div className="mt-10 flex flex-col gap-3 sm:flex-row">
            <Link to="/contact" className="btn-glass-primary">
              {t('nav.contactWebouse')}
            </Link>
            <Link to="/" className="btn-glass-secondary">
              {t('common.backToHome')}
            </Link>
          </div>
        </div>
      </section>
    </PublicPageShell>
  );
};

export default LegalPage;
